var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _circle3, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M130,98.3L130,98.3c-3.2,0-5.8-2.6-5.8-5.8V39.4c0-3.2,2.6-5.8,5.8-5.8h0c3.2,0,5.8,2.6,5.8,5.8v53.1 C135.8,95.7,133.2,98.3,130,98.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M249.4,92.9L249.4,92.9c0,3.2-2.6,5.8-5.8,5.8H133.5c-3.2,0-5.8-2.6-5.8-5.8v0c0-3.2,2.6-5.8,5.8-5.8h110.1 C246.8,87.1,249.4,89.7,249.4,92.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M302.5,183.8L302.5,183.8c-3.2,0-5.8-2.6-5.8-5.8V39.4c0-3.2,2.6-5.8,5.8-5.8l0,0c3.2,0,5.8,2.6,5.8,5.8V178 C308.3,181.2,305.7,183.8,302.5,183.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M243.4,148.2L243.4,148.2c-3.2,0-5.8-2.6-5.8-5.8v-46c0-3.2,2.6-5.8,5.8-5.8h0c3.2,0,5.8,2.6,5.8,5.8v46 C249.2,145.6,246.6,148.2,243.4,148.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#B3C5C9",
    strokeWidth: 9.3882,
    strokeMiterlimit: 10,
    cx: 302.1,
    cy: 25.2,
    r: 9.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#B3C5C9",
    strokeWidth: 9.3882,
    strokeMiterlimit: 10,
    cx: 131.1,
    cy: 25.2,
    r: 9.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M469,98.3L469,98.3c3.2,0,5.8-2.6,5.8-5.8V39.4c0-3.2-2.6-5.8-5.8-5.8l0,0c-3.2,0-5.8,2.6-5.8,5.8v53.1 C463.2,95.7,465.8,98.3,469,98.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M349.6,92.9L349.6,92.9c0,3.2,2.6,5.8,5.8,5.8h110.1c3.2,0,5.8-2.6,5.8-5.8v0c0-3.2-2.6-5.8-5.8-5.8H355.4 C352.2,87.1,349.6,89.7,349.6,92.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M355.6,148.2L355.6,148.2c3.2,0,5.8-2.6,5.8-5.8v-46c0-3.2-2.6-5.8-5.8-5.8h0c-3.2,0-5.8,2.6-5.8,5.8v46 C349.8,145.6,352.4,148.2,355.6,148.2z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#B3C5C9",
    strokeWidth: 9.3882,
    strokeMiterlimit: 10,
    cx: 467.9,
    cy: 25.2,
    r: 9.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M421.8,338.7c0-66.5-53.9-120.4-120.4-120.4s-120.4,53.9-120.4,120.4c0,47.2,27.2,88,66.7,107.7 c2.7,1.3,8.2,3.8,8.2,10.4c0,6.6,0,29.1,0,29.1c0,6.6,5.4,12,12,12h73.7c6.6,0,12-5.4,12-12c0,0,0-25.1,0-32.2c0-6.4,4.3-8.8,6.4-10 C396.9,423.1,421.8,383.9,421.8,338.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M334.2,525.9h-65.5c-4.4,0-8-3.6-8-8l0,0c0-4.4,3.6-8,8-8h65.5c4.4,0,8,3.6,8,8l0,0 C342.3,522.3,338.7,525.9,334.2,525.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M327.1,554.4h-51.3c-4.4,0-8-3.6-8-8l0,0c0-4.4,3.6-8,8-8h51.3c4.4,0,8,3.6,8,8l0,0 C335.1,550.8,331.5,554.4,327.1,554.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C5C9",
    d: "M320,582.9h-37c-4.4,0-8-3.6-8-8v0c0-4.4,3.6-8,8-8h37c4.4,0,8,3.6,8,8v0C328,579.3,324.4,582.9,320,582.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M374.1,325.1c-16.2-3.4-28.5-17.7-28.5-35c0-4.2,0.8-8.1,2.1-11.9 c-5.6-4.6-11.9-8.3-18.8-11.1c-6.6,7.9-16.4,12.9-27.5,12.9c-11,0-20.9-5-27.4-12.9c-6.6,2.7-12.8,6.3-18.3,10.7 c1.4,3.8,2.2,7.9,2.2,12.3c0,17.4-12.5,31.9-29,35.1c-0.4,3.3-0.8,6.6-0.8,9.9c0,4.5,0.4,8.9,1.2,13.1c16.3,3.3,28.6,17.7,28.6,35 c0,3.4-0.5,6.7-1.4,9.8c5.9,4.6,12.5,8.3,19.6,10.9c6.5-6.5,15.4-10.6,25.4-10.6c9.9,0,18.9,4.1,25.4,10.6 c7.3-2.7,14.1-6.5,20.1-11.3c-0.8-3-1.3-6.1-1.3-9.4c0-17,11.9-31.3,27.9-34.8c0.8-4.3,1.3-8.7,1.3-13.3 C374.8,331.7,374.6,328.4,374.1,325.1z M302.1,376.1c-22.5,0-40.8-18.3-40.8-40.8c0-22.5,18.3-40.8,40.8-40.8 c22.5,0,40.8,18.3,40.8,40.8C343,357.9,324.7,376.1,302.1,376.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterprise);
export default __webpack_public_path__ + "static/media/icon-enterprise.19c74c992cc56197f3410fa8bdf6a5fb.svg";
export { ForwardRef as ReactComponent };